<template>
  <div class="container-fluid p-3">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="h3 my-0 mx-0 text-foreground">Review Images</h3>
        <p class="text-muted-foreground text-sm">Manage automated review image generation and sharing</p>
      </div>
      <div class="flex items-center space-x-4">
        <router-link
          v-if="user && user.business"
          :to="{
            name: 'request-reviews',
            params: {
              /* eslint-disable-next-line vue/camelcase */
              unique_id: user.business.unique_id + '-' + user.business.id,
            },
          }"
          class="btn bg-primary space-x-3 round-xl px-4 request-review-btn"
          target="_blank"
          ><i class="uil uil-star"></i
          ><span class="text-sm font-medium"> Request Review</span>
        </router-link>
      </div>
    </div>
    <hr class="pb-4 pt-0" style="margin: 0 -40px 0 -20px !important" />
      <!-- Content Section -->
      <div class="review-images-content">
          <!-- Image Cards Grid -->
          <div class="images-grid">
            <!-- Facebook Image Card -->
            <div class="image-card image-card-facebook">
              <div class="image-card-header">
                <div class="image-icon-wrapper">
                  <svg width="64" height="64" viewBox="0 0 24 24" aria-hidden="true">
                    <rect width="24" height="24" rx="5" ry="5" fill="#1877F2"></rect>
                    <path d="M16.671 15.543l.532-3.47h-3.328v-2.25c0-.949.465-1.874 1.956-1.874h1.514V5.096s-1.374-.235-2.686-.235c-2.741 0-4.533 1.662-4.533 4.669v2.66H7.078v3.47h3.047v8.385c.61.096 1.235.146 1.875.146.64 0 1.265-.05 1.875-.146v-8.385h2.796z" fill="#fff"></path>
                  </svg>
                </div>
                <h3 class="image-card-title">Facebook Image</h3>
                <p class="image-card-description">Design the image that will be posted to Facebook.</p>
              </div>
              <div class="image-card-footer">
                <router-link :to="{ name: 'new-business.review-image-editor', params: { platform: 'facebook' } }" class="edit-btn">
                  Edit
                </router-link>
              </div>
            </div>

            <!-- Instagram Image Card -->
            <div class="image-card image-card-instagram">
              <div class="image-card-header">
                <div class="image-icon-wrapper">
                  <svg width="64" height="64" viewBox="0 0 24 24" aria-hidden="true">
                    <defs>
                      <linearGradient id="igCard" x1="0%" y1="100%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#F58529"></stop>
                        <stop offset="25%" stop-color="#FEDA77"></stop>
                        <stop offset="50%" stop-color="#DD2A7B"></stop>
                        <stop offset="75%" stop-color="#8134AF"></stop>
                        <stop offset="100%" stop-color="#515BD4"></stop>
                      </linearGradient>
                    </defs>
                    <rect width="24" height="24" rx="5.5" ry="5.5" fill="url(#igCard)"></rect>
                    <path d="M12 2.982c2.937 0 3.285.011 4.445.064a6.087 6.087 0 0 1 2.042.379 3.408 3.408 0 0 1 1.265.823 3.408 3.408 0 0 1 .823 1.265 6.087 6.087 0 0 1 .379 2.042c.053 1.16.064 1.508.064 4.445s-.011 3.285-.064 4.445a6.087 6.087 0 0 1-.379 2.042 3.643 3.643 0 0 1-2.088 2.088 6.087 6.087 0 0 1-2.042.379c-1.16.053-1.508.064-4.445.064s-3.285-.011-4.445-.064a6.087 6.087 0 0 1-2.042-.379 3.408 3.408 0 0 1-1.265-.823 3.408 3.408 0 0 1-.823-1.265 6.087 6.087 0 0 1-.379-2.042C2.993 15.285 2.982 14.937 2.982 12s.011-3.285.064-4.445a6.087 6.087 0 0 1 .379-2.042 3.408 3.408 0 0 1 .823-1.265 3.408 3.408 0 0 1 1.265-.823 6.087 6.087 0 0 1 2.042-.379c1.16-.053 1.508-.064 4.445-.064M12 1c-2.987 0-3.362.013-4.535.066a8.074 8.074 0 0 0-2.67.511 5.392 5.392 0 0 0-1.949 1.27 5.392 5.392 0 0 0-1.27 1.949 8.074 8.074 0 0 0-.511 2.67C1.013 8.638 1 9.013 1 12s.013 3.362.066 4.535a8.074 8.074 0 0 0 .511 2.67 5.392 5.392 0 0 0 1.27 1.949 5.392 5.392 0 0 0 1.949 1.27 8.074 8.074 0 0 0 2.67.511C8.638 22.987 9.013 23 12 23s3.362-.013 4.535-.066a8.074 8.074 0 0 0 2.67-.511 5.625 5.625 0 0 0 3.219-3.219 8.074 8.074 0 0 0 .511-2.67C22.987 15.362 23 14.987 23 12s-.013-3.362-.066-4.535a8.074 8.074 0 0 0-.511-2.67 5.392 5.392 0 0 0-1.27-1.949 5.392 5.392 0 0 0-1.949-1.27 8.074 8.074 0 0 0-2.67-.511C15.362 1.013 14.987 1 12 1z" fill="white"></path>
                    <path d="M12 6.351A5.649 5.649 0 1 0 17.649 12 5.649 5.649 0 0 0 12 6.351zm0 9.316A3.667 3.667 0 1 1 15.667 12 3.667 3.667 0 0 1 12 15.667z" fill="white"></path>
                    <circle cx="17.872" cy="6.128" r="1.32" fill="white"></circle>
                  </svg>
                </div>
                <h3 class="image-card-title">Instagram Image</h3>
                <p class="image-card-description">Design the image that will be posted to Instagram.</p>
              </div>
              <div class="image-card-footer">
                <router-link :to="{ name: 'new-business.review-image-editor', params: { platform: 'instagram' } }" class="edit-btn">
                  Edit
                </router-link>
              </div>
            </div>

            <!-- Google Business Profile Image Card -->
            <div v-if="user.has_premium_plan" class="image-card image-card-google google-card-right">
              <div class="image-card-header">
                <div class="image-icon-wrapper">
                  <svg width="64" height="64" viewBox="0 0 24 24" aria-hidden="true">
                    <rect width="24" height="24" rx="5" ry="5" fill="#fff"></rect>
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"></path>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path>
                  </svg>
                </div>
                <h3 class="image-card-title">Google Business Profile</h3>
                <p class="image-card-description">Design the image that will be posted to Google Business Profile.</p>
              </div>
              <div class="image-card-footer">
                <router-link :to="{ name: 'new-business.review-image-editor', params: { platform: 'gbp' } }" class="edit-btn">
                  Edit
                </router-link>
              </div>
            </div>
          </div>

          <!-- Posting Settings Card -->
          <div class="settings-card">
            <div class="settings-card-header">
              <h3 class="settings-title">Posting Settings</h3>
              <p class="settings-description">Configure when and how reviews are automatically shared to social media platforms.</p>
            </div>
            <div class="settings-card-body">
              <div class="settings-grid">
                <!-- Auto posting master & Email for approval -->
                <div class="settings-section">
                  <h4 class="section-title">Auto Posting</h4>
                  <div class="platform-list">
                    <div class="platform-item">
                      <div class="platform-info platform-info-with-hint">
                        <label class="platform-label">Enable auto posting</label>
                        <span class="field-hint-inline">When on, reviews can be automatically shared to the platforms below according to the schedule.</span>
                      </div>
                      <b-form-checkbox
                        v-model="postingSettings.autoPostingEnabled"
                        switch
                        class="platform-toggle feedback-switch-style"
                      ></b-form-checkbox>
                    </div>
                    <div class="platform-item">
                      <div class="platform-info platform-info-with-hint">
                        <label class="platform-label">Send email for approval</label>
                        <span class="field-hint-inline">When on, you’ll receive an email to approve each post before it goes live.</span>
                      </div>
                      <b-form-checkbox
                        v-model="postingSettings.sendEmailForApproval"
                        switch
                        class="platform-toggle feedback-switch-style"
                      ></b-form-checkbox>
                    </div>
                  </div>
                </div>

                <!-- Platform Auto-Sharing -->
                <div class="settings-section">
                  <h4 class="section-title">Platform Auto-Sharing</h4>
                  <div class="platform-list">
                    <!-- Google Business Profile Toggle -->
                    <div class="platform-item">
                      <div class="platform-info">
                        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                          <rect width="24" height="24" rx="5" ry="5" fill="#fff"></rect>
                          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"></path>
                          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path>
                          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path>
                          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path>
                        </svg>
                        <label class="platform-label">Google Business Profile</label>
                      </div>
                      <b-form-checkbox
                        v-model="postingSettings.googleEnabled"
                        switch
                        class="platform-toggle feedback-switch-style"
                      ></b-form-checkbox>
                    </div>

                    <!-- Facebook Toggle -->
                    <div class="platform-item">
                      <div class="platform-info">
                        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                          <rect width="24" height="24" rx="5" ry="5" fill="#1877F2"></rect>
                          <path d="M16.671 15.543l.532-3.47h-3.328v-2.25c0-.949.465-1.874 1.956-1.874h1.514V5.096s-1.374-.235-2.686-.235c-2.741 0-4.533 1.662-4.533 4.669v2.66H7.078v3.47h3.047v8.385c.61.096 1.235.146 1.875.146.64 0 1.265-.05 1.875-.146v-8.385h2.796z" fill="#fff"></path>
                        </svg>
                        <label class="platform-label">Facebook</label>
                      </div>
                      <b-form-checkbox
                        v-model="postingSettings.facebookEnabled"
                        switch
                        class="platform-toggle feedback-switch-style"
                      ></b-form-checkbox>
                    </div>

                    <!-- Instagram Toggle -->
                    <div class="platform-item">
                      <div class="platform-info">
                        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                          <defs>
                            <linearGradient id="igSettings" x1="0%" y1="100%" x2="100%" y2="0%">
                              <stop offset="0%" stop-color="#F58529"></stop>
                              <stop offset="25%" stop-color="#FEDA77"></stop>
                              <stop offset="50%" stop-color="#DD2A7B"></stop>
                              <stop offset="75%" stop-color="#8134AF"></stop>
                              <stop offset="100%" stop-color="#515BD4"></stop>
                            </linearGradient>
                          </defs>
                          <rect width="24" height="24" rx="5.5" ry="5.5" fill="url(#igSettings)"></rect>
                          <path d="M12 2.982c2.937 0 3.285.011 4.445.064a6.087 6.087 0 0 1 2.042.379 3.408 3.408 0 0 1 1.265.823 3.408 3.408 0 0 1 .823 1.265 6.087 6.087 0 0 1 .379 2.042c.053 1.16.064 1.508.064 4.445s-.011 3.285-.064 4.445a6.087 6.087 0 0 1-.379 2.042 3.643 3.643 0 0 1-2.088 2.088 6.087 6.087 0 0 1-2.042.379c-1.16.053-1.508.064-4.445.064s-3.285-.011-4.445-.064a6.087 6.087 0 0 1-2.042-.379 3.408 3.408 0 0 1-1.265-.823 3.408 3.408 0 0 1-.823-1.265 6.087 6.087 0 0 1-.379-2.042C2.993 15.285 2.982 14.937 2.982 12s.011-3.285.064-4.445a6.087 6.087 0 0 1 .379-2.042 3.408 3.408 0 0 1 .823-1.265 3.408 3.408 0 0 1 1.265-.823 6.087 6.087 0 0 1 2.042-.379c1.16-.053 1.508-.064 4.445-.064M12 1c-2.987 0-3.362.013-4.535.066a8.074 8.074 0 0 0-2.67.511 5.392 5.392 0 0 0-1.949 1.27 5.392 5.392 0 0 0-1.27 1.949 8.074 8.074 0 0 0-.511 2.67C1.013 8.638 1 9.013 1 12s.013 3.362.066 4.535a8.074 8.074 0 0 0 .511 2.67 5.392 5.392 0 0 0 1.27 1.949 5.392 5.392 0 0 0 1.949 1.27 8.074 8.074 0 0 0 2.67.511C8.638 22.987 9.013 23 12 23s3.362-.013 4.535-.066a8.074 8.074 0 0 0 2.67-.511 5.625 5.625 0 0 0 3.219-3.219 8.074 8.074 0 0 0 .511-2.67C22.987 15.362 23 14.987 23 12s-.013-3.362-.066-4.535a8.074 8.074 0 0 0-.511-2.67 5.392 5.392 0 0 0-1.27-1.949 5.392 5.392 0 0 0-1.949-1.27 8.074 8.074 0 0 0-2.67-.511C15.362 1.013 14.987 1 12 1z" fill="white"></path>
                          <path d="M12 6.351A5.649 5.649 0 1 0 17.649 12 5.649 5.649 0 0 0 12 6.351zm0 9.316A3.667 3.667 0 1 1 15.667 12 3.667 3.667 0 0 1 12 15.667z" fill="white"></path>
                          <circle cx="17.872" cy="6.128" r="1.32" fill="white"></circle>
                        </svg>
                        <label class="platform-label">Instagram</label>
                      </div>
                      <b-form-checkbox
                        v-model="postingSettings.instagramEnabled"
                        switch
                        class="platform-toggle feedback-switch-style"
                      ></b-form-checkbox>
                    </div>
                  </div>
                </div>

                <!-- Posting Schedule -->
                <div class="settings-section">
                  <h4 class="section-title">Posting Schedule</h4>
                  <div class="schedule-content">
                    <!-- Days to post -->
                    <div class="schedule-field">
                      <label class="field-label">Days to post:</label>
                      <div class="days-list">
                        <button
                          v-for="day in daysOfWeek"
                          :key="day.value"
                          type="button"
                          class="day-badge"
                          :class="{ active: postingSettings.postingDays.includes(day.value) }"
                          @click="toggleDay(day.value)"
                        >
                          {{ day.label }}
                        </button>
                      </div>
                    </div>

                    <!-- Time window and Min rating -->
                    <div class="schedule-row">
                      <div class="schedule-field">
                        <label class="field-label">Time window:</label>
                        <div class="time-input-group">
                          <input
                            v-model="postingSettings.timeWindowStart"
                            type="text"
                            class="time-input"
                            placeholder="9am"
                          />
                          <span class="time-separator">to</span>
                          <input
                            v-model="postingSettings.timeWindowEnd"
                            type="text"
                            class="time-input"
                            placeholder="3pm"
                          />
                        </div>
                      </div>
                      <div class="schedule-field">
                        <label class="field-label">Min. rating:</label>
                        <div class="rating-select-group">
                          <b-form-select
                            v-model="postingSettings.minRating"
                            :options="ratingOptions"
                            class="rating-select"
                          ></b-form-select>
                          <span class="rating-suffix">stars or higher</span>
                        </div>
                      </div>
                    </div>

                    <!-- Daily limit and Timezone -->
                    <div class="schedule-row">
                      <div class="schedule-field">
                        <label class="field-label">Daily limit:</label>
                        <div class="limit-select-group">
                          <b-form-select
                            v-model="postingSettings.dailyLimit"
                            :options="limitOptions"
                            class="limit-select"
                          ></b-form-select>
                          <span class="limit-suffix">posts per day</span>
                        </div>
                      </div>
                      <div class="schedule-field">
                        <label class="field-label">Timezone:</label>
                        <b-form-select
                          v-model="postingSettings.timezone"
                          :options="timezoneOptions"
                          class="timezone-select"
                        ></b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Post Text Template -->
              <div class="template-section">
                <h4 class="section-title">Post Text Template</h4>
                <div class="template-content">
                  <div class="placeholders-info">
                    <span class="placeholders-label">Available placeholders:</span>
                    <div class="placeholders-list">
                      <span class="placeholder-badge">{rating}</span>
                      <span class="placeholder-badge">{content}</span>
                      <span class="placeholder-badge">{author}</span>
                    </div>
                  </div>
                  <b-textarea
                    v-model="postingSettings.postTemplate"
                    class="template-textarea"
                    rows="3"
                    placeholder="Enter your custom post text here... Use {rating}, {content}, and {author} placeholders."
                  ></b-textarea>
                </div>
              </div>

              <!-- Save Button -->
              <div class="settings-footer">
                <b-button
                  variant="primary"
                  class="save-btn"
                  :disabled="saving"
                  @click="saveSettings"
                >
                  <b-spinner v-if="saving" small class="mr-2" />
                  Save Settings
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import '../../../design/custom/components/_dashboard.scss'

export default {
  name: 'ReviewImages',
  data() {
    return {
      saving: false,
      postingSettings: {
        autoPostingEnabled: true,
        sendEmailForApproval: false,
        googleEnabled: true,
        facebookEnabled: true,
        instagramEnabled: true,
        postingDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        timeWindowStart: '9am',
        timeWindowEnd: '3pm',
        minRating: 4,
        dailyLimit: 1,
        timezone: 'America/New_York',
        postTemplate: '',
      },
      daysOfWeek: [
        { label: 'Monday', value: 'monday' },
        { label: 'Tuesday', value: 'tuesday' },
        { label: 'Wednesday', value: 'wednesday' },
        { label: 'Thursday', value: 'thursday' },
        { label: 'Friday', value: 'friday' },
        { label: 'Saturday', value: 'saturday' },
        { label: 'Sunday', value: 'sunday' },
      ],
      ratingOptions: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ],
      limitOptions: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ],
      timezoneOptions: [
        { value: 'America/New_York', text: 'Eastern Time (New York)' },
        { value: 'America/Chicago', text: 'Central Time (Chicago)' },
        { value: 'America/Denver', text: 'Mountain Time (Denver)' },
        { value: 'America/Los_Angeles', text: 'Pacific Time (Los Angeles)' },
      ],
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    toggleDay(day) {
      const index = this.postingSettings.postingDays.indexOf(day)
      if (index > -1) {
        this.postingSettings.postingDays.splice(index, 1)
      } else {
        this.postingSettings.postingDays.push(day)
      }
    },
    loadSettings() {
      const social = this.user?.business?.social_settings
      if (!social) {
        return
      }
      const auto = social.auto_sharing_settings || {}
      const ps = auto.posting_settings || social.posting_settings
      if (ps && typeof ps === 'object') {
        this.postingSettings = { ...this.postingSettings, ...ps }
      }
      // Keep UI in sync with canonical scheduler fields returned on auto_sharing_settings
      if (Object.prototype.hasOwnProperty.call(auto, 'fb_enabled')) {
        this.postingSettings.facebookEnabled = !!auto.fb_enabled
      }
      if (Object.prototype.hasOwnProperty.call(auto, 'ig_enabled')) {
        this.postingSettings.instagramEnabled = !!auto.ig_enabled
      }
      if (Object.prototype.hasOwnProperty.call(auto, 'gbp_enabled')) {
        this.postingSettings.googleEnabled = !!auto.gbp_enabled
      }
      if (auto.share_days && Array.isArray(auto.share_days)) {
        this.postingSettings.postingDays = auto.share_days.map((d) =>
          typeof d === 'string' ? String(d).toLowerCase() : d
        )
      }
      if (auto.share_start_time) {
        this.postingSettings.timeWindowStart = auto.share_start_time
      }
      if (auto.share_end_time) {
        this.postingSettings.timeWindowEnd = auto.share_end_time
      }
      if (auto.minimum_rating !== undefined && auto.minimum_rating !== null) {
        this.postingSettings.minRating = Number(auto.minimum_rating)
      }
      if (auto.share_daily_limit !== undefined && auto.share_daily_limit !== null) {
        this.postingSettings.dailyLimit = Number(auto.share_daily_limit)
      }
      if (auto.timezone) {
        this.postingSettings.timezone = auto.timezone
      }
    },
    saveSettings() {
      if (!this.user || !this.user.business) {
        console.error('User or business not available')
        return
      }
      this.saving = true
      // Save settings to backend
      this.$store
        .dispatch('business/saveSocialPostingSettings', {
          business_id: this.user.business.id,
          posting_settings: this.postingSettings,
        })
        .then(() => {
          this.saving = false
          this.loadSettings()
          this.$bvToast.toast('Settings saved successfully', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })
        })
        .catch((error) => {
          this.saving = false
          this.$bvToast.toast('Failed to save settings. Please try again.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          console.error(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>

.review-images-header {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 32px;
  margin: 0 -24px 24px -24px;

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-title {
      font-size: 20px;
      font-weight: 700;
      color: #1f2937;
      margin: 0;
    }

    .page-subtitle {
      color: #6b7280;
      font-size: 14px;
      margin-top: 4px;
    }

    .header-actions {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .request-review-btn {
      background-color: rgb(36, 99, 235) !important;
      color: #ffffff !important;
    }
  }
}

.review-images-content {
  padding: 0 8px;
}

.content-wrapper {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.images-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  .google-card-right {
    @media (min-width: 768px) {
      grid-column: 2;
    }
    padding-bottom: 24px;
  }
}

.image-card {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-align: center;

  &.image-card-facebook,
  &.image-card-instagram {
    padding-bottom: 24px;
  }

  .image-card-header {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 24px;

    .image-icon-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }

    .image-card-title {
      font-weight: 600;
      font-size: 18px;
      color: #1f2937;
      margin: 0;
    }

    .image-card-description {
      font-size: 14px;
      color: #6b7280;
      margin: 0;
    }
  }

  .image-card-footer {
    padding: 0 24px;

    .edit-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      white-space: nowrap;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      height: 40px;
      padding: 8px 16px;
      width: 100%;
      border: 1px solid #e5e7eb;
      background: white;
      color: #1f2937;
      text-decoration: none;
      transition: all 0.2s;

      &:hover {
        background: #f9fafb;
        color: #1f2937;
        text-decoration: none;
      }
    }
  }
}

.settings-card {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  .settings-card-header {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 24px;

    .settings-title {
      font-size: 24px;
      font-weight: 600;
      line-height: 1.2;
      color: #1f2937;
      margin: 0;
    }

    .settings-description {
      font-size: 14px;
      color: #6b7280;
      margin: 0;
    }
  }

  .settings-card-body {
    padding: 24px 24px 0 24px;
  }
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.settings-section {
  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 16px;
  }
}

.platform-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.platform-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;

  .platform-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;

    .platform-label {
      font-weight: 500;
      font-size: 14px;
      color: #1f2937;
      margin: 0;
      cursor: pointer;
      flex-shrink: 0;
    }

    .field-hint-inline {
      font-size: 12px;
      color: #6b7280;
      margin: 0;
    }

    &.platform-info-with-hint {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }

  .platform-toggle {
    &.feedback-switch-style {
      margin: 0;
      
      :deep(.custom-control-input:checked ~ .custom-control-label::before) {
        background-color: #3b82f6;
        border-color: #3b82f6;
      }
      
      :deep(.custom-control-input:not(:checked) ~ .custom-control-label::before) {
        background-color: #e5e7eb;
        border-color: #e5e7eb;
      }
      
      :deep(.custom-switch .custom-control-label::after) {
        background-color: white;
      }
      
      :deep(.custom-switch) {
        padding-left: 2.5rem;
        min-height: 1.5rem;
      }
      
      :deep(.custom-control-label) {
        padding-top: 0;
        padding-left: 0.5rem;
        cursor: pointer;
        line-height: 1.5rem;
      }
      
      :deep(.custom-control-label::before) {
        width: 2.5rem;
        height: 1.25rem;
        border-radius: 0.625rem;
        top: 0.125rem;
        left: -2.5rem;
      }
      
      :deep(.custom-control-label::after) {
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        top: 0.25rem;
        left: -2.375rem;
        transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
      }
      
      :deep(.custom-control-input:checked ~ .custom-control-label::after) {
        transform: translateX(1.25rem);
      }
    }
  }
}

.schedule-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.schedule-field {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .field-label {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 8px;
  }
}

.days-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.day-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid transparent;
  font-weight: 600;
  transition: all 0.2s;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 12px;
  background: transparent;
  color: #1f2937;
  border-color: #e5e7eb;

  &:hover {
    background: #f9fafb;
  }

  &.active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;

    &:hover {
      background: #2563eb;
    }
  }
}

.schedule-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.time-input-group {
  display: flex;
  align-items: center;
  gap: 4px;

  .time-input {
    flex: 0 0 auto;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
    background: white;
    padding: 8px 12px;
    font-size: 12px;
    width: 64px;
    text-align: center;

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
    }
  }

  .time-separator {
    font-size: 12px;
    color: #6b7280;
  }
}

.rating-select-group,
.limit-select-group {
  display: flex;
  align-items: center;
  gap: 4px;

  .rating-select,
  .limit-select {
    flex: 0 0 auto;
    height: 32px;
    width: 64px;
    font-size: 12px;
    padding: 4px 8px;
  }

  .rating-suffix,
  .limit-suffix {
    font-size: 12px;
    color: #6b7280;
  }
}

.timezone-select {
  height: 32px;
  font-size: 12px;
  padding: 4px 8px;
  min-height: 38px;
}

.schedule-field .timezone-select {
  margin-top: 4px;
}

.template-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 12px;
  }
}

.template-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.placeholders-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;

  .placeholders-label {
    color: #6b7280;
  }

  .placeholders-list {
    display: flex;
    gap: 4px;
  }
}

.placeholder-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid transparent;
  font-weight: 600;
  font-size: 12px;
  padding: 4px 8px;
  background: #f3f4f6;
  color: #1f2937;
}

.template-textarea {
  width: 100%;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: white;
  padding: 12px;
  font-size: 14px;
  min-height: 80px;
  resize: none;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }
}

.settings-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-bottom: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;

  .save-btn {
    height: 40px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    background: #3b82f6;
    border-color: #3b82f6;
    color: white;

    &:hover {
      background: #2563eb;
      border-color: #2563eb;
    }

    &:disabled {
      background: #9ca3af;
      border-color: #9ca3af;
    }
  }
}
</style>

